<div class="page-section series-form-page">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/admin/series-listing']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/series-listing']">Series</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					{{ title }}
				</li>
			</ul>
		</div>
	</div>
	<div class="page-section-content">
		<page-loader *ngIf="!isLoaded"></page-loader>
        <ng-container *ngIf="mode === 'create'">
            <form
                novalidate
                [formGroup]="createDailySeriesForm"
            >
                <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">
                            <h3>- Step 1 -</h3>
                            <p>
                                Download the following spreadsheet and have it filled
                                out by the client.
                            </p>
                            <a href="/assets/documents/daily-series-template.xlsx" download>
                                Download Template
                            </a>

                            <h3>- Step 2 -</h3>
                                <div class="app-c-form-group">
                                    <label class="app-c-form--label">Title</label>
                                    <input class="app-c-form-control" formControlName="title" required type="text" />
                                    <div class="error-message" *ngIf="f.title.touched && f.title.errors?.required">
                                        Title is required
                                    </div>
                                </div>
                                <div class="icon-input">
                                    <label for="resources" translate
                                        >Import Resources</label
                                    >
                                    <div>
                                        <input
                                            type="file"
                                            style="display: inline-block"
                                            (change)="incomingfile($event)"
                                            placeholder="Upload file"
                                            accept=".xlsx"
                                        />
                                    </div>
                                    <span
                                        class="text-danger"
                                        *ngIf="
                                            fileError === '' &&
                                            f.excelFile.touched &&
                                            f.excelFile.errors?.required
                                        "
                                    >
                                        Please upload the file to import
                                    </span>
                                    <span class="text-danger" *ngIf="fileError !== ''">
                                        {{ fileError }}
                                    </span>
                                </div>
                    <div class="fixed-footer">
                        <p class="red" *ngIf="submitButtonPressed && !createDailySeriesForm.valid && errors === ''">Please check the errors</p>
                        <p class="red">{{errors}}</p>
                        <button type="button" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">Save</button>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="mode !== 'create'">
            <form novalidate [formGroup]="courseEditForm">
                <div id="dailyseries-section" class="form-wrapper-80" *ngIf="isLoaded">

                    <div class="app-c-form-group">
                        <label class="app-c-form--label" translate>Series Category</label>
                        <select class="app-c-form-control" formControlName="category">
                            <option *ngFor="let category of categoryList" [value]="category.ID">
                                {{ category.Title }}
                            </option>
                        </select>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label">Daily Boost - English</label>
                        <textarea class="app-c-form-control" placeholder="Daily Boost - English" formControlName="quotesen"></textarea>
                        <div class="error-message" *ngIf="g.quotesen.touched && g.quotesen.errors?.required">
                            The Quote (English) is required
                        </div>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label">Daily Boost - French</label>
                        <textarea class="app-c-form-control" placeholder="Daily Boost - French" formControlName="quotesfr"></textarea>
                        <div class="error-message" *ngIf="g.quotesfr.touched && g.quotesfr.errors?.required">
                            The Quote (French) is required
                        </div>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label">Daily Boost - Spanish</label>
                        <textarea class="app-c-form-control" placeholder="Daily Boost - Spanish" formControlName="quoteses"></textarea>
                        <div class="error-message" *ngIf="g.quoteses.touched && g.quoteses.errors?.required">
                            The Quote (Spanish) is required
                        </div>
                    </div>

                    <div class="fixed-footer">
                        <p class="red" *ngIf="submitButtonPressed && !courseEditForm.valid && errors === ''">Please check the errors
                        </p>
                        <p class="red">{{errors}}</p>
                        <button type="button" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()">Save</button>
                    </div>
                </div>
            </form>
        </ng-container>
	</div>
</div>
